import { observable, action, makeObservable } from 'mobx';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../../../commonv3/api/RemoteResourceV3';
import { UserAddress } from '../../../../types/userAddresses';
import { userAddressesApi } from '../../../../apis/userAddresses';
import { UserAddressFormState } from '../../../../containers/application/states/UserAddressFormState';

export class AddressChangePaneState {
  addressFormState: UserAddressFormState = new UserAddressFormState();
  currentAddress: RemoteResourceV3<UserAddress> = RemoteResourceV3.loading();
  newAddress?: Blob = null;
  submitting = false;

  constructor() {
    makeObservable(this, {
      currentAddress: observable,
      newAddress: observable,
      submitting: observable,
      init: action.bound,
      reloadUserAddress: action.bound,
      submit: action.bound,
    });
  }

  async init() {
    this.reloadUserAddress();
  }

  async reloadUserAddress() {
    const currentAddress = await updateRemoteResourceV3(
      this.currentAddress,
      (v) => (this.currentAddress = v),
      () => userAddressesApi.findAddress()
    );
    const newAddress: UserAddress = {
      zipcode: currentAddress.zipcode || '',
      prefecture: currentAddress.prefecture || '',
      city: currentAddress.city || '',
      address: currentAddress.address || '',
      building: currentAddress.building || '',
    };
    this.addressFormState.init(newAddress);
  }

  async submit() {
    this.submitting = true;
    try {
      this.addressFormState.clearErrors();
      try {
        const updateValue = this.addressFormState.fields;
        const formData: UserAddress = {
          zipcode: updateValue.zipcode.getDirtyValue(),
          prefecture: updateValue.prefecture.getDirtyValue(),
          city: updateValue.city.getDirtyValue(),
          address: updateValue.address.getDirtyValue(),
          building: updateValue.building.getDirtyValue(),
        };
        await userAddressesApi.updateAddress(formData);
      } catch (error) {
        this.addressFormState.setErrors(error.body);
      }
    } finally {
      this.submitting = false;
    }
  }
}
